"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getActions = void 0;
var vuex_1 = require("vuex");
var createImports_1 = require("../helpers/createImports");
var addHelpers_1 = require("./addHelpers");
/**
 * Get Vuex actions object, mapped for export
 */
function getActions(actions, namespace) {
    if (namespace === void 0) { namespace = ''; }
    return addHelpers_1.AddHelpers.wrap(createImports_1.createImports(actions, vuex_1.mapActions, namespace));
}
exports.getActions = getActions;
